const AdminUserStore = {
  namespaced: true,
  state: {
    listMode: [],
    pagination: [],
    query: [],
    sort: []
  },
  mutations: {
    setPagination(state, { datatype, limit, offset }) {
      const newList = state.pagination.filter((item) => item.datatype !== datatype);
      newList.push({ datatype: datatype, limit: limit, offset: offset });
      state.pagination = newList;
    },
    setQuery(state, { datatype, query }) {
      const newList = state.query.filter((item) => item.datatype !== datatype);
      newList.push({ datatype: datatype, query: query });
      state.query = newList;
    },
    setSort(state, { datatype, sort }) {
      const newList = state.query.filter((item) => item.datatype !== datatype);
      newList.push({ datatype: datatype, sort: sort });
      state.sort = newList;
    },
    setListMode(state, { datatype, mode }) {
      const newList = state.listMode.filter((item) => item.datatype !== datatype);
      newList.push({ datatype: datatype, mode: mode });
      state.listMode = newList;
    }
  },
  actions: {},
  getters: {}
};

export default AdminUserStore;
